import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#004B84",
        lightPrimary: "#F3F1FF",
        secondary: "#424242",
        background: "#DBD6D6",
        accent: "#003399",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        lightWhite: "#f5f8fd",
        lightBlue: "#4EB2FF",
        secondaryText: "#514C4C"
      }
    }
  },
  icons: {
    iconfont: "fa"
  }
};

export default new Vuetify(opts);
